export default __webpack_public_path__ + "static/media/team.c3673ac6.jpg";